function getSasriaStateCode(inputStateCd) {
    switch (inputStateCd) {
        case 'WC':
            return 'WE_CP';
        case 'WE_CP':
            return 'WE_CP';
        case 'EC':
            return 'EA_CP';
        case 'EA_CP':
            return 'EA_CP';
        case 'NC':
            return 'NO_CP';
        case 'NW':
            return 'NO_WE';
        case 'FS':
            return 'FR_ST';
        case 'NL':
            return 'KW_NT';
        case 'KZN':
            return 'KW_NT';
        case 'LP':
            return 'Limpopo';
        case 'MP':
            return 'Mpumalanga';
        case 'NO_CP':
            return 'NO_CP';
        case 'NO_WE':
            return 'NO_WE';
        case 'FR_ST':
            return 'FR_ST';
        case 'KW_NT':
            return 'KW_NT';
        case 'Limpopo':
            return 'Limpopo';
        case 'Mpumalanga':
            return 'Mpumalanga';
        default:
            return 'Gauteng';
    }
}

function getCountry(countryCd){
    switch (countryCd) {
        case 'ZA':
            return 'South Africa';
        case 'ZAF':
            return 'South Africa';
        default:
            return 'South Africa';
    }
}

function parseGoogleAddressResponse(response, addrType){
    var addrComponent = response.address_components;
  
    for(const addr of addrComponent){
        var types = addr.types;
        if(types.includes(addrType)){
            return addr.short_name;
        }
    }
    return '';
}

function buildGoogleAddressRequest(address){
    let ret = '';
    if(address.addressLine1){
        if (ret.trim().length > 0) { ret += ', '; }
        ret += address.addressLine1;
    }
    if(address.city){
        if (ret.trim().length > 0) { ret += ', '; }
        ret += address.city;
    }
    if(address.state){
        if (ret.trim().length > 0) { ret += ', '; }
        ret += address.state;
    }
    if(address.postalCode){
        if (ret.trim().length > 0) { ret += ', '; }
        ret += address.postalCode;
    }
    if(address.countryCode){
        if (ret.trim().length > 0) { ret += ', '; }
        ret += address.countryCode;
    }
    return ret;
}

export {
    getSasriaStateCode,
    parseGoogleAddressResponse,
    getCountry,
    buildGoogleAddressRequest
}